export default ({ src }) => (
  (src && src.indexOf('images.contentstack') !== -1 && src.indexOf('?auto=webp') === -1) ? (
    `${src}?auto=webp`
  ) : (
    src
  )
);
